/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { ErrorsDetailsTypes } from '../types';
import { setEntityName } from './object';

type InfosTypes = {
  [key: string]: boolean;
};

export const handleCodeErrorsResponse = (params: {
  errors: ErrorsDetailsTypes[];
  definitions: unknown[] | null | undefined;
}): InfosTypes => {
  let infos = {};

  const { errors, definitions } = params;

  definitions?.forEach((element: any) => {
    errors?.map((error: any) => {
      element.CODE_ERRORS.map((err: any) => {
        if (error.entity === setEntityName(element.ENDPOINT_API_PATH)) {
          const errorCodeStr = error.errorCode?.toString();
          if (err.code === errorCodeStr) {
            infos = {
              ...infos,
              [err.bussinessErrorVariant]: true,
            };
          }
          const currentKey = err.bussinessErrorVariant;
          if (!(currentKey in infos)) {
            infos = {
              ...infos,
              [err.bussinessErrorVariant]: false,
            };
          }
        }
      });
    });
  });

  return infos;
};
